<template>
  <div>
    <div class="web-head">
      <div class="mark" v-show="inputExpand" @click="closeSearch"></div>
      <div class="mark" v-show="inputExpands" @click="closeSearch"></div>
      <div class="head">
        <div class="type-page">
          <div class="login">
            <span>您好，欢迎来到安徽省网商协会</span>
          </div>
        </div>
      </div>
      <div class="contain">
        <div class="type-page">
          <div class="logo flex-row-center-start-space-between">
            <img src="@imgs/nav/logo1.png" alt="" />
            <div class="qr-code">
              <div>
                <div class="pic"></div>
                <p>官方微信公众号</p>
              </div>
              <div>
                <a
                  href="https://anhuiec.oss-cn-hangzhou.aliyuncs.com/img/%E9%99%84%E4%BB%B61%EF%BC%9A%E5%AE%89%E5%BE%BD%E7%9C%81%E7%BD%91%E5%95%86%E5%8D%8F%E4%BC%9A%E5%8D%95%E4%BD%8D%E4%BC%9A%E5%91%98%E7%94%B3%E8%AF%B7%E8%A1%A8.doc"
                >
                  <div class="pic"></div>
                  <p>加入协会</p>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 一级菜单 -->
      <div class="menus">
        <div class="type-page">
          <div class="tabs">
            <div
              class="tab flex-row-center"
              :class="{ 'tab-active': active == 0 }"
              data-key="0"
              @click="changeTab"
            >
              <i>首页</i>
            </div>
            <div
              class="tab flex-row-center"
              :class="{ 'tab-active': active == 1 }"
              data-key="1"
              @click="changeTab"
            >
              <i>资讯动态</i>
            </div>
             <div
              class="tab flex-row-center"
              :class="{ 'tab-active': active == 8 }"
              data-key="8"
              @click="changeTab"
            >
              <i>会员风采</i>
            </div>
            <div
              class="tab flex-row-center"
              :class="{ 'tab-active': active == 5 }"
              data-key="5"
              @click="changeTab"
            >
              <i
                ><img
                  class="pdr-5"
                  :src="active == 5 ? imgSrc2 : imgSrc1"
                  alt=""
                  v-if="ifActiveNow == 'false'"
                />
                活动赛事</i
              >
            </div>
            <!-- <div
              class="tab flex-row-center"
              :class="{ 'tab-active': active == 2 }"
              data-key="2"
              @click="changeTab"
            >
              <i>服务体系</i>
            </div> -->
            <div
              class="tab flex-row-center"
              :class="{ 'tab-active': active == 3 }"
              data-key="3"
              @click="changeTab"
            >
              <i>示范创建</i>
            </div>
            <div
              class="tab flex-row-center"
              :class="{ 'tab-active': active == 4 }"
              data-key="4"
              @click="changeTab"
            >
              <i>电商优选</i>
            </div>
            <!-- <div
              class="tab flex-row-center"
              :class="{ 'tab-active': active == 7 }"
              data-key="7"
              @click="changeTab"
            >
              <i>信用共建</i>
            </div> -->
           
            <div
              class="tab flex-row-center"
              :class="{ 'tab-active': active == 6 }"
              data-key="6"
              @click="changeTab"
            >
              <i>关于我们</i>
            </div>
          </div>
        </div>
      </div>
      <!-- 二级菜单 -->
      <!-- <div class="sub_menus type-page">
        <router-link
          :to="{ name: 'Newstrend' }"
          :class="{ indicator: curRoute === '/news/Newstrend' ? true : false }"
          >新闻动态</router-link
        >
        <router-link
          :to="{ name: 'Policy' }"
          :class="{ indicator: curRoute === '/news/Policy' ? true : false }"
          >政策发布</router-link
        >
        <router-link
          :to="{ name: 'Notice' }"
          :class="{ indicator: curRoute === '/news/Notice' ? true : false }"
          >通知公告</router-link
        >
        <router-link
          :to="{ name: 'Report' }"
          :class="{ indicator: curRoute === '/news/Report' ? true : false }"
          >研究报告</router-link
        >
         <router-link
          :to="{ name: 'Safety' }"
          :class="{ indicator: curRoute === '/news/Safety' ? true : false }"
          >安全生产</router-link
        >
        <router-link
          :to="{ name: 'serviceSystem' }"
          :class="{ indicator: curRoute === '/services/' }"
          >课程资源</router-link
        >
        <a @click="navAndanchor('serviceSystem', '.servicecenters')"
          >服务中心</a
        >
        <a @click="navAndanchor('serviceSystem', '.servicess')">供需对接</a>
      </div> -->
      <!-- 搜索弹出框 -->
      <transition name="fade">
        <div class="search-box" v-show="inputExpand">
          <div class="search">
            <div>
              <div class="logo flex-row-center iconPosition">
                <!-- <img src="@imgs/nav/logo.png" alt="" /> -->
                <img src="@imgs/nav/logo1.png" alt="" />
              </div>
              <div class="searchWant">
                <div class="searchValue">
                  <i class="el-icon-search"></i
                  ><input
                    type="text"
                    placeholder="搜索您需要的信息"
                    v-model="searchValue"
                  />
                </div>
                <div class="searchNow"  @click="navPosition('search')" >搜索</div>
              </div>
              <div class="everyone">
                <p><span></span>大家都在搜<span></span></p>
                <div>
                  一体化开发<span></span>营商环境<span></span>消费扶贫<span
                  ></span>皖货严选
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
      <!-- 遮罩层 -->
      <div v-show="showReg" class="cover" @click="offShowReg"></div>

      <!--微信扫码登录界面-->
      <!-- <div class="login1" v-show="inputExpands">
        <div class="toptitle" v-show="logins == 1">
          <p :class="type == 1 ? 'sureType' : ''">扫码登陆</p>
          <p @click="changeLogin(1)" :class="type == 2 ? 'sureType' : ''">
            账密登录
          </p>
        </div>
        <div class="toptitle" v-show="logins == 2">微信注册</div>
        <div class="img"><img :src="picPath" alt="" /></div>
        <div class="bottomNew">
          <span v-show="logins == 1">请使用微信扫描二维码登陆</span
          ><span v-show="logins == 2">请关注公众号注册</span>
        </div>
      </div> -->
      <!-- 用户名密码登录输入框 -->
      <!-- <div class="login2" v-show="userphone">
        <div class="toptitle">
          <p @click="changeLogin(2)" :class="type == 1 ? 'sureType' : ''">
            扫码登陆
          </p>
          <p :class="type == 2 ? 'sureType' : ''">账密登录</p>
        </div>
        <div class="form-info">
          <el-form
            :model="user"
            :rules="UserRules"
            label-width="1.2rem"
            ref="registersRefs"
          >
            <el-form-item label="用户名" prop="username">
              <el-input
                v-model="user.username"
                placeholder="请输入用户名"
                maxlength="20"
              ></el-input>
            </el-form-item>
            <el-form-item label="密码" prop="password">
              <el-input
                v-model="user.password"
                placeholder="请输入密码"
                type="password"
              ></el-input>
            </el-form-item>
            <el-form-item label="验证码" prop="key">
              <el-input
                v-model="user.key"
                placeholder="请输入验证码"
              ></el-input>
            </el-form-item>
            <img :src="picPaths" alt="" @click="getregisters" />
          </el-form>
          <el-button type="primary" @click="validForms('registersRefs')"
            >登录</el-button
          >
        </div>
      </div> -->
      
      <!-- 登录界面 -->
      <div class="contart-main" v-show="showlogin">
        <div class="detele" @click="detele">
          <img src="../images/deetele.png" alt="">
        </div>
        <div class="Change">
          <img src="../images/zhuC.png" class="into" :style="{marginTop: !imgshow ? '10px' : 0}">
          <div class="change">
            <img src="../images/userss.png" @click="change(1)" alt="">
          </div>
        </div>
        <div class="contart">
        <!-- 扫码登录 -->
          <div class="left">
            <div class="title">
              <div class="Sline"></div>
              <div class="title-zi">扫码登录</div>
              <div class="Sline"></div>
            </div>
          <!-- <img src="../images/icons/jiantou.png" alt=""> -->
            <div style="display:flex; justify-content: center;">
              <div class="img">
              <img :src="picPath" style="width:100%" alt="">
            </div>
            </div>
            <div class="foot-sign">
              <p>使用微信扫描二维码</p>
              <p>关注<strong style="color:white">“安徽省电子商务服务平台”</strong>公众号</p>
            </div>
          </div>
          <hr>
          <!-- 账号登录 -->
          <div class="right">
            <div class="type">
              <a href="javascript:void(0)" id="Account" class="active" @click="Type(1,$event)">账号登录</a>
              <a href="javascript:void(0)" id="Phone" @click="Type(2,$event)">手机号登录</a>
            </div>
            <!-- 账号登录 -->
            <div class="type-main">
             <!-- 账号登录 -->
              <div class="type-admin" v-if="typelogin">
                <el-input placeholder="请输入账号" prefix-icon="el-icon-user" v-model="users.username"></el-input>
                <el-input type="password" placeholder="请输入密码" prefix-icon="el-icon-lock" v-model="users.password"></el-input>
                <div class="verify">
                  <el-input placeholder="请输入验证码" v-model="users.key">
                  <img class="phoneimg" slot="prefix" src="../images/varimg.png"/></el-input>
                  <el-button type="primary" @click="Verify(3)">验证码</el-button>
                </div>
                <img v-if="imgshow" :src="picPaths" alt="">
              </div>
              <!-- 手机号登录 -->
              <div class="type-number" v-else-if="!typelogin">
                
                <div class="phone">
                  <el-button>+86</el-button>
                 <el-input placeholder="请输入手机号" v-model="users.phone">
                  <img class="phoneimg" slot="prefix" src="../images/phone2.png"/></el-input>
                </div>
                <div class="verify">
                 <el-input placeholder="请输入验证码" v-model="verify">
                 <img class="phoneimg" slot="prefix" src="../images/varimg.png"/></el-input>
                  <el-button type="primary" @click="Verify(1)">{{getmessage}}</el-button>
                </div>
              </div>
              <el-button type="primary" @click="loginTrue">登录</el-button>
              <p><a class="wj" href="#">忘记账号名</a> <a class="wj" href="#">忘记密码</a></p>
            </div>
          </div>
        </div> 
        <div class="foot"><span>*登录视为你已同意<a style="text-decoration: underline;color:#367AB7 ;" href="#/serverM">服务条款</a>，<a style="text-decoration: underline;color: #367AB7 ;" href="#/agrementM">隐私政策</a></span></div>
      </div>
      <!-- 注册界面 -->
      <div class="contart-main zhuce" v-show="showenroll">
      <div class="detele" @click="detele">
        <img src="../images/deetele.png" alt="">
      </div>
       <div class="Change">
          <img src="../images/dengL.png" class="into" :style="{marginTop: !imgshow ? '10px' : 0}">
          <div class="change">
            <img src="../images/llogin.png" @click="change(2)" alt="">
          </div>
        </div>
        <div class="contart">
        <!-- 扫码登录 -->
          <div class="left">
            <div class="title">
              <div class="Sline"></div>
              <div class="title-zi">扫码注册</div>
              <div class="Sline"></div>
            </div>
          
          <!-- <img src="../images/icons/jiantou.png" alt=""> -->
          <div style="display:flex; justify-content: center;">
            <div class="img">
              <img :src="picPath" style="width:100%" alt="">
            </div>
          </div>
          <div class="foot-sign">
            <p>使用微信扫描二维码</p>
            <p>关注<strong style="color:white">“安徽省电子商务服务平台”</strong>公众号</p>
          </div>
          </div>
          <hr>
          <!-- 账号登录 -->
          <div class="right right-p">
            <!-- <div class="type1 type">
                <a href="javasript:void(0)" class="active1">手机号注册</a>
                <p>未注册手机号验证码通过后将自动注册</p>
            </div> -->
            <!-- 手机号登录 -->
            <!-- <div class="type-main">
              <div class="type-number">
                <div class="phone">
                  <el-button>+86</el-button>
                 <el-input placeholder="请输入手机号" prefix-icon="
el-icon-mobile-phone" v-model="users.phone"></el-input>
                </div>
                <div class="verify">
                 <el-input placeholder="请输入验证码" prefix-icon="el-icon-lock" v-model="verify"></el-input>
                 <hr>
                  <el-button type="primary" @click="Verify(2)">{{getZCmessage}}</el-button>
                </div>
              </div>
              <el-button type="primary" @click="enroll">注册</el-button>
            </div> -->
          </div>
        </div> 
        <div class="foot"><span>*注册视为你已同意<a style="text-decoration: underline;color:#367AB7 ;" href="#/serverM">服务条款</a>，<a style="text-decoration: underline;color: #367AB7 ;" href="#/agrementM">隐私政策</a></span></div>
      </div>
    </div>
    <div class="mb-head">
      <div class="nav" @click="showMbmenu" style="display: none">
        <!-- <img src="@imgs/common/header_nav_mb.png" alt="" /> -->
      </div>
      <div class="smoke" @click="showMbmenu" v-show="Mbmenu"></div>
      <!-- <img src="@imgs/common/head_logo_mb.png" alt="" /> -->
      <div class="nav_menu" :class="Mbmenu ? 'showNavMenu' : ''">
        <ul>
          <li data-key="0" @click="changeTab">首页</li>
          <li data-key="1" @click="changeTab">咨询动态</li>
          <li data-key="5" @click="changeTab">活动赛事</li>
          <li data-key="2" @click="changeTab">服务资源</li>
          <li data-key="3" @click="changeTab">示范创建</li>
          <li data-key="4" @click="changeTab">电商优选</li>
          <li data-key="8" @click="changeTab">法律法规</li>
          <li data-key="7" @click="changeTab">信用共建</li>
          <li data-key="6" @click="changeTab">关于我们</li>
        </ul>
        <div class="nav_wx">
          <img src="@imgs/pages/home/erweimaa.jpg" alt="" />
          <p>
            <img src="@imgs/pages/home/weixin1.png" alt="" />扫码关注官方微信号
          </p>
        </div>
      </div>
    </div>
    <!-- <Qrcode :dialogVisible.sync="dialogVisible" @closeDialog="closeDialog" /> -->
  </div>
</template>

<script>
import logoUrl from "@/images/icons/userLogo.png";
// import getUserIP from '../utils/ip'
import {
  getphoneVerify,
  getphoneVerifyZC,
  phoneverify,
  getZCvritfy,
  phoneLogin,
  phoneLogin1,
  loginVerify,
  login,
  userLogin,
  userlogin,
  userInfo,
  getpic,
  registers,
  getmessage,
  findByContent,
  getPVUV
} from "../apis/apis.js";
import Qrcode from "../components/qrcode/index.vue";
export default {
  name: "web-head",
  props: {
    active: {
      type: Number,
      default: 0,
    },
  },
  components: {
    // Qrcode,
  },
  data() {
    let validMobile = async (rule, value, next) => {
      rule = /^1[3456789]\d{9}$/;
      if (!rule.test(value)) {
        return next(new Error("非法手机号"));
      }
    };
    let validPass = async (rule, value, next) => {
      rule = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,16}$/;
      if (!rule.test(value)) {
        return next(new Error("密码为6位及以上18位及以下的数字和字母组成"));
      }
    };
    return {
      // 登录方式展示
      imgshow:false,
      watchh:false,
      typelogin:true,
      showenroll:false,
      disabled:false,
      checked:false,
      pd:'',
      userInfos:'',
      // 登录信息
      users:{
        phone:"",
        password: "",
        key: "",
        verKey: "",
        // username: JSON.parse(localStorage.getItem('user')).loginName,
        username:'',
        openid:''
      },
      // 验证码
      verify:'',
      // 登录展示
      showlogin: false,
      logo: "",
      // 登录打开公众号二维码
      dialogVisible: false,
      //进入注册界面隐藏二级菜单
      hideSubMenu: false,
      ifActiveNow: "false",
      //定时器设置60秒一次短信
      clickMessage: 0,
      setIntervalMessage: "",
      //获取验证码按钮
      // getmessage: "短信验证",
      getmessage:'发送验证码',
      getZCmessage:'发送验证码',
      //手机端导航显示隐藏
      Mbmenu: false,
      //注册进度条
      actives: 1,
      //是否使用用户名密码登录
      userphone: false,
      //验证用户是否有账号
      registers: false,
      //搜索词汇
      searchValue: "",
      //搜索弹框
      inputExpand: false,
      //登录注册弹框
      inputExpands: false,
      imgSrc1: require("@imgs/icons/1.gif"),
      imgSrc2: require("@imgs/icons/2.gif"),
      //遮罩层
      showReg: false,
      //二维码地址
      picPath: "",
      //登录还是注册
      logins: 1,
      //显示用户名和头像
      showNews: false,
      //用户名
      username: "",
      //穿给后端的值，用于信息一对一传递
      ticket: "",
      //验证码图片地址
      picPaths: "",
      type: 2,
      //验证规则
      UserRules: {
        phone: [
          { required: true, message: "请输入您的手机号", trigger: "blur" },
          { validator: validMobile, trigger: "blur" },
        ],
        key: [{ required: true, message: "请输入验证码", trigger: "blur" }],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
          { validator: validPass, trigger: "blur" },
        ],
        username: [
          { required: true, message: "请输入用户名", trigger: "blur" },
        ],
      },
      user: {
        userType: "3",
        phone: "",
        password: "",
        key: "",
        verKey: "",
        openid: "",
        username: "",
      },
    };
  },
  created() {
    this.hideSubMenu = false;
    // this.getuserInfo()
    this.getifActive();
    // this.getconnect()
    this.getLogo()
    // this.InitCartList()
  },
  mounted(){
    this.watchh = false
    // getUserIP((ip) => {
    //   sessionStorage.setItem('ip',ip)
    // })
  },
  computed: {
    curRoute() {
      return this.$route.path;
    },
    userInfo() {
      return JSON.parse(sessionStorage.getItem("user-login")) || "";
    },
    nickname() {
      return sessionStorage.getItem("nickname");
    },
  },
  watch:{
    watchh() {
      this.$message({
        title:'提醒',
        type:'info',
        message:'注册账号'
      })
      this.$router.push('/registerM')
    }
  },
  methods: {
    // 进入注册界面
    // 关闭
    detele() {
      this.showlogin = false
      this.showenroll = false
      this.inputExpands = false;
      this.showReg = false;
      this.registers = false;
      this.userphone = false;
      for(let key in this.users) {
        this.users[key] = ''
      }
      this.verify = ''
      this.picPaths = ''
      this.imgshow = false
    },
    // 获取手机注册验证码
    geterollVarity () {
      let reg = /^1[23456789]\d{9}$/;
      if (!reg.test(this.users.phone)) {
        this.$message({
          title: "错误",
          type: "error",
          message: "请正确填写手机号码",
        });
      } else {
        //点击后60s之后才能获取信息
        this.disabled = true
        clearInterval(this.setIntervalMessage);
        this.clickMessage = 60;
        this.getZCmessage = `请在${this.clickMessage}s后重试`;
        this.setIntervalMessage = setInterval(() => {
          this.clickMessage--;
          this.getZCmessage = `请在${this.clickMessage}s后重试`;
          if (this.clickMessage == 0) {
            clearInterval(this.setIntervalMessage);
            this.getZCmessage  = `获取验证码`;
            this.disabled = false
          }
        }, 1000);
        this.$ajaxGet(getZCvritfy,{
          phone:this.users.phone
        }).then(res=>{
          if (res.data.code != 0) {
            this.$message({
              title:'错误',
              type:'error',
              message:res.data.msg
            })
            clearInterval(this.setIntervalMessage);
            this.getZCmessage = `获取验证码`;
            this.disabled = false
          }
          else {
            this.$message({
              title:'正确',
              type:'success',
              message:res.data.msg
            })
          }
        })
          .catch((err) => {
            this.$alert(err + "网络请求异常，请稍后再试！", "警告", {
              confirmButtonText: "确定",
              type: "error",
            });
          });
      }  
    },
    //手机号注册验证码验证
    errollVarity() {
      this.$ajaxGet(getphoneVerifyZC,{
        phone:this.users.phone,
        verifyCode:this.verify
      }).then(res=>{
        if (res.data.code != 0) {
          this.$message({
            title:'错误',
            type:'error',
            message:res.data.msg
          })
        }
        else {
          this.$router.push({
            path:'/registerM',
            query:{
              phone:this.users.phone,
              type:'1'
            }
          })
        }
      })
    },
    // 手机号登录
    PHoneLogin(v) {
      this.$ajaxGet(phoneLogin1,{
        phone:this.users.phone,
        verifyCode:this.verify
      }).then(res=>{
        if (res.data.code != 0) {
          this.$message({
            title:'错误',
            type:'error',
            message:res.data.msg
          })
          return
        }
        sessionStorage.setItem("token", res.data.data.token);
        sessionStorage.setItem("nickname", res.data.data.user.nickName);
        sessionStorage.setItem("openid", res.data.data.user.openid);
        if(res.data.data.user.openid === null || res.data.data.user.openid === ''){
          this.$message({
            title:'错误',
            type:'error',
            message:'账号非法，请重新注册'
          })
          return
        }
        this.getuserNew(res.data.data.user.openid, "nav");
      })
        .catch((err) => {
          this.$alert(err + "网络请求异常，请稍后再试！", "警告", {
            confirmButtonText: "确定",
            type: "error",
          });
        });
    },
    // 登录界面
    Type(v,event) {
      var span = document.querySelector('.type').querySelectorAll('a')
      if (v === 1) {
        this.typelogin = true
        this.users.phone = "",
        this.users.password =  "",
        this.users.key =  "",
        this.users.verKey =  "",
        this.users.username =  "",
        this.users.openid = ''
        this.verify = ''
      }else if(v === 2){
        this.typelogin = false
        this.users.phone = "",
        this.users.password =  "",
        this.users.key =  "",
        this.users.verKey =  "",
        this.users.username =  "",
        this.users.openid = ''
        this.verify = ''
      }
      span.forEach(element => {
        element.className = ''
        event.target.className = 'active'
      });
    },
    // 注册界面
    change(v) {
      if (v === 1) {
        this.showenroll = true
        this.showlogin = false
        this.users.phone = "",
        this.users.password =  "",
        this.users.key =  "",
        this.users.verKey =  "",
        this.users.username =  "",
        this.users.openid = ''
        this.verify = ''
      } else {
        this.showenroll = false
        this.showlogin = true
        this.users.phone = "",
        this.users.password =  "",
        this.users.key =  "",
        this.users.verKey =  "",
        this.users.username =  "",
        this.users.openid = ''
        this.verify = ''
      }
    },
    // 切换登录/注册
    Login(v) {
      if (v === 1) {
        this.showlogin = true
        this.showReg = true
      }else if(v === 2){
        this.showenroll = true
        this.showReg =true
      }
      this.login(v)
    },
    // 注册导航
    enroll(){
      if (this.checked === false){
        this.$message({
          title:"错误",
          type:"error",
          message:"请勾选服务和隐私条款"
        })
      }
      else {
        this.errollVarity()
      }
    },
    // 获取验证码
    Verify(v) {
      // 手机登录
      if (v === 1) {
        this.phoneLOgin()
      }
      // 注册
      else if(v === 2) {
        this.geterollVarity()
        // this.getMbmessage()
        // this.phoneLOgin()
      }
      // 账号登录
      else if(v === 3) {
        this.getregisters()
        
      }
    },
    // 账号登录
    loginTrue(){
      if (this.typelogin === true) {
        this.validForms()
      }
      else {
        this.PHoneLogin()
      }
    },
    getLogo() {
      console.log(1);
      // const logo = JSON.parse(sessionStorage.getItem("user-login")) ? JSON.parse(sessionStorage.getItem("user-login")).headImgUrl : ''
      // if (logo != null && logo != '' && JSON.parse(sessionStorage.getItem("user-login")).headImgUrl != '') {
      //   this.logo = logo
      // } else {
      //   this.logo = logoUrl
      // }
      JSON.parse(sessionStorage.getItem("user-login")).userType == 3 ? this.logo = JSON.parse(sessionStorage.getItem("user-login")).headImgUrl : this.logo =JSON.parse(sessionStorage.getItem("user-login")).logo
      if(this.logo === null || this.logo === '') {
        this.logo = logoUrl
      }
    },
    closeDialog() {
      this.dialogVisible = false;
    },
    //点击注册按钮的回调
    toRegister() {
      this.$router.push("/register");
      this.hideSubMenu = true;
    },
    handleCommand(v) {
      if (v == "a") {
        this.$router.push({
          name: "userInfo",
        });
        // this.$router.push({name:'userInfo'})
      } else {
        sessionStorage.removeItem("token");
        sessionStorage.removeItem("user-login");
        if (this.$route.name == "home") {
          this.$router.go(0);
        } else {
          this.$router.push({ name: "home" });
        }
      }
    },
    //判断现在是否有活动
    getifActive() {
      let active = sessionStorage.getItem("ifActiveNow");
      if (active == null) {
        setTimeout(() => {
          this.getifActive();
        }, 0);
      } else {
        this.ifActiveNow = sessionStorage.getItem("ifActiveNow");
      }
    },
    // 手机号获取验证码
    phoneLOgin() {
      let reg = /^1[23456789]\d{9}$/;
      if (!reg.test(this.users.phone)) {
        this.$message({
          title: "错误",
          type: "error",
          message: "请正确填写手机号码",
        });
      }
      else {
        this.disabled = true
        clearInterval(this.setIntervalMessage);
        this.clickMessage = 60;
        this.getmessage = `请在${this.clickMessage}s后重试`;
        this.setIntervalMessage = setInterval(() => {
          this.clickMessage--;
          this.getmessage = `请在${this.clickMessage}s后重试`;
          if (this.clickMessage == 0) {
            clearInterval(this.setIntervalMessage);
            this.getmessage = `获取验证码`;
            this.disabled = false
          }
        }, 1000);
        this.$ajaxGet(phoneverify,{
          phone:this.users.phone
        }).then(res=>{
          if (res.data.code != 0) {
            this.$message({
              title: "错误",
              type: "error",
              message: "未注册，请确认手机号",
            });
            clearInterval(this.setIntervalMessage);
            this.getmessage = `获取验证码`;
          }    
          else {
            this.$message({
              title: "成功",
              type: "success",
              message: res.data.msg,
            });
          }
        })
          .catch((err) => {
            this.$alert(err + "网络请求异常，请稍后再试！", "警告", {
              confirmButtonText: "确定",
              type: "error",
            });
          });
      }
    },
    //更换用户类型
    changeType(v) {
      this.user.userType = v;
    },
    //获取短信验证码
    getMbmessage() {
      let reg = /^1[23456789]\d{9}$/;
      if (!reg.test(this.users.phone)) {
        this.$message({
          title: "错误",
          type: "error",
          message: "请正确填写手机号码",
        });
      } else {
        //点击后60s之后才能获取信息
        this.disabled = true
        this.clickMessage = 60;
        this.getmessage = `请在${this.clickMessage}s后重试`;
        this.setIntervalMessage = setInterval(() => {
          this.clickMessage--;
          this.getmessage = `请在${this.clickMessage}s后重试`;
          if (this.clickMessage == 0) {
            clearInterval(this.setIntervalMessage);
            this.getmessage = `获取验证码`;
            this.disabled = false
          }
        }, 1000);
        //发送验证码
        this.$ajaxGet(`${getmessage}`, { phone:this.users.phone})
          .then((res) => {
            if (res.data.code != 0) {
              this.$message({
                title: "错误",
                type: "error",
                message: "网络错误，请重新刷新",
              });
            }
            this.$message({
              title:'正确',
              type:'success',
              message:res.data.msg
            })
          })
          .catch((err) => {
            this.$alert(err + "网络请求异常，请稍后再试！", "警告", {
              confirmButtonText: "确定",
              type: "error",
            });
          });
      }
    },
    //手机端导航显示隐藏
    showMbmenu() {
      if (this.Mbmenu == false) {
        this.Mbmenu = true;
      } else {
        this.Mbmenu = false;
      }
    },
    //切换注册步骤
    changestops(type) {
      if (type == 1) {
        this.actives++;
      } else {
        this.actives--;
      }
    },
    overregister() {
      this.actives++;
    },
    //切换账密登录
    changeLogin(type) {
      this.type = type;
      if (type == 1) {
        this.user.phone = "";
        this.user.password = "";
        this.user.key = "";
        this.user.verKey = "";
        this.user.secondpassword = "";
        this.user.openid = "";
        this.inputExpands = false;
        this.userphone = true;
        this.getregisters();
      } else {
        this.inputExpands = true;
        this.userphone = false;
      }
    },
    navtoUser(name) {
      if (name == "registerM") {
        this.dialogVisible = true;
      } else {
        this.$router.push({ name });
      }
    },
    navtolink(){

    },
    //点击账密登录
    validForms() {
      // this.$refs[form].validate((valid) => {
      //   if (!valid) {
      //     this.$message({
      //       title: "错误",
      //       type: "error",
      //       message: "请正确填写信息",
      //     });
      //   } else {
      if (this.users.username == "") {
        this.$message({
          title: "错误",
          type: "error",
          message: "用户名不能为空",
        });
        return;
      }
      else if (this.users.password == "") {
        this.$message({
          title: "错误",
          type: "error",
          message: "密码不能为空",
        });
        return;
      }
      this.$ajaxPost(`${userlogin}`,this.users)
        .then((res) => {
          console.log("登录", res);
          if (res.data.code != 0) {
            if (res.data.msg === '操作失败') {
              this.$message({
                title:'错误',
                type:'error',
                message:'账号输入错误'
              })
              return
            }
            if (res.data.msg === '密码错误') {
              this.$message({
                title:'错误',
                type:'error',
                message:'密码错误'
              })
              return
            }
            if (res.data.msg === '验证码不正确') {
              this.$message({
                title:'错误',
                type:'error',
                message:'验证码错误'
              })
              return
            }
            // this.$message({
            //   title: "错误",
            //   type: "error",
            //   message: res.data.msg,
            // });
            // this.$router.push({name:'infoprompt'})
          } else {
            this.userphone = false;
            this.$message({
              title: "登陆成功",
              type: "success",
              message: "登陆成功",
            });
            sessionStorage.setItem("token", res.data.data.token);
            sessionStorage.setItem("openid", res.data.data.openid);
            if (res.data.data.openid) {
              this.getuserNew(res.data.data.openid);
            } else {
              this.dialogVisible = true;
            }
          }
        })
        .catch((err) => {
          this.$alert(err + "网络请求异常，请稍后再试！", "警告", {
            confirmButtonText: "确定",
            type: "error",
          });
        });
    // }
      // });
    },
    //点击提交注册
    validForm () {
      this.$ajaxPost(`${registers}`, {}, {
        phone:this.users.phone,
        key:this.verify
      })
        .then((res) => {
          console.log(res);
          if (res.data.code == 201) {
            this.$message({
              title: "错误",
              type: "error",
              message: "手机号重复,请重新输入",
            });
            return;
          } else {
            if (res.data.code == 500) {
              this.$message({
                title: "错误",
                type: "error",
                message: "验证码错误,请重新填写",
              });
              return;
            }
            if (res.data.code != 0) {
              this.$message({
                title: "错误",
                type: "error",
                message: res.data.msg + ",请重新刷新",
              });
              return;
            } else {
              this.$message({
                title: "绑定成功",
                type: "success",
                message: "绑定成功",
              });
              console.log(res);
              sessionStorage.setItem("token", res.data.data.token);
              this.getuserNew(res.data.user.openid, "nav");
            }
          }
        })
        .catch((err) => {
          this.$alert(err + "网络请求异常，请稍后再试！", "警告", {
            confirmButtonText: "确定",
            type: "error",
          });
        });
    },
    //进入页面判断用户是否已经登陆
    // getuserInfo() {
    //   let userLogin = sessionStorage.getItem("user-login");
    //   if (userLogin) {
    //     userLogin = JSON.parse(userLogin);
    //     this.showNews = true;
    //     this.userInfo = userLogin;
    //   } else {
    //     this.showNews = false;
    //   }
    // },
    //关闭搜索弹框
    
    closeSearch() {
      this.inputExpand = false;
      this.inputExpands = false;
    },
    //打开搜索弹框
    expand() {
      this.inputExpand = true;
    },
    //跳转页面
    changeTab(ev) {
      const key = ev.currentTarget.dataset.key;
      this.$emit("change", parseInt(key));
      if (key == 0) {
        this.$router.push({ name: "home", params: { name: "首页" } });
      }
      if (key == 1) {
        this.$router.push({ name: "News", params: { name: "资讯动态" } });
      }
      if (key == 2) {
        this.$router.push({ name: "Services", params: { name: "服务资源" } });
      }
      if (key == 3) {
        this.$router.push({
          name: "Demonstration",
          params: { name: "示范园企" },
        });
      }
      if (key == 4) {
        this.$router.push({
          name: "preferred",
          params: { name: "电商优选" },
        });
      }
      if (key == 5) {
        this.$router.push({ name: "Activities" });
      }
      if (key == 6) {
        this.$router.push({ name: "Aboutus", params: { name: "关于我们" } });
      }
      if (key == 7) {
        this.$router.push({ name: "credit", params: { name: "信用共建" } });
      }
      if (key == 8) {
        this.$router.push({ name: "companyy",  query:{id:1005}} ).then(res =>{
          window.location.reload();
        })
        
        // this.$router.go(0);
      }
    },
    //登录的二维码请求
    login(v) {
      this.type = 2;
      this.inputExpands = true;
      this.logins = v;
      this.$ajaxGet(`${login}`, {})
        .then((res) => {
          console.log(res);
          if (res.data.code != 0) {
            return this.$message({
              title: "错误",
              type: "error",
              message: res.data.msg + ",请重新刷新",
            });
          }
          this.picPath = res.data.msg;
          let arr = res.data.msg.split("=");
          this.ticket = arr[1];
          this.showReg = true;
          this.getconnect();
        })
        .catch((err) => {
          this.$alert(err + "网络请求异常，请稍后再试！", "警告", {
            confirmButtonText: "确定",
            type: "error",
          });
        });
    },
    //关闭遮罩层
    offShowReg() {
      this.showlogin = false
      this.showenroll = false
      this.inputExpands = false;
      this.showReg = false;
      this.registers = false;
      this.userphone = false;
      for(let key in this.users) {
        this.users[key] = ''
      }
      this.verify = ''
      this.picPaths = ''
      this.imgshow = false
    },
    //点击搜索获取内容
    searchNow() {
      // let val=this.searchValue
    },
    //网页长连接保证用户登录
    getconnect() {
      let that = this;
      // 判断浏览器是否支持WebSocket
      let is_support = "WebSocket" in window;
      if (is_support) {
        // 打开一个 web socket
        // let ws = new WebSocket(`${userLogin}/${that.ticket}`);
        let ws = new WebSocket(`${userLogin}/${that.ticket}`);
        ws.onopen = function () {
          console.log("WebSocket连接成功");
          ws.send(that.ticket);
        };
        //  Web Socket 已连接上
        //  接受服务器数据
        ws.onmessage = (e) => {
          console.log(e.data);
          const data = JSON.parse(JSON.parse(JSON.stringify(e.data)));
          console.log("websocket", data);
          if (data.token && data.openid) {
            this.$message.success("登录成功", 1);
            this.inputExpands = false;
            this.showReg = false;
            this.showNews = true;
            this.user.openid = data.openid;
            this.getuserNew(data.openid);
            sessionStorage.setItem("token", data.token);
            sessionStorage.setItem("nickname", data.nickName);
            sessionStorage.setItem("openid", data.openid);
          }
          else if(data.openid){
            sessionStorage.setItem("openidz", data.openid);
            this.watchh = true
            this.getinZC()
          }
        };
        //监听窗口关闭事件，当窗口关闭时，主动去关闭websocket连接，防止连接还没断开就关闭窗口，server端会抛异常。
        window.onbeforeunload = function () {
          ws.close();
        };
      } else {
        this.$alert("浏览器版本过低，请更新浏览器", "警告", {
          confirmButtonText: "确定",
          type: "error",
        });
      }
    },
    //获取验证码
    getregisters() {
      this.$ajaxGet(`${getpic}`, {})
        .then((res) => {
          if (res.data.code != 0) {
            this.$message({
              title: "错误",
              type: "error",
              message: res.data.msg + ",请重新刷新",
            });
          }
          console.log(res);
          this.imgshow = true
          this.picPaths = res.data.data.ClientImage;
          // this.user.verKey = res.data.data.ClientKey;
          this.users.verKey = res.data.data.ClientKey;
        })
        .catch((err) => {
          this.$alert(err + "网络请求异常，请稍后再试！", "警告", {
            confirmButtonText: "确定",
            type: "error",
          });
        });
    },
    //获取用户信息
    getuserNew(openid, nav) {
      this.$ajaxGet(`${userInfo}/${openid}`, {})
        .then((res) => {
          if (res.data.code != 0) {
            this.$message({
              title: "错误",
              type: "error",
              message: res.data.msg + ",请重新刷新",
            });
          }
          console.log(res.data.data.logo);
          this.showNews = true;
          this.userInfo = res.data.data;
          this.userInfos = res.data.data
          console.log(this.userInfo);
          console.log(this.userInfos);
          this.showReg = false;
          this.registers = false;
          // this.logo = res.data.data.headImgUrl || logoUrl;
          // res.data.data.userType == 3 ? this.logo = res.data.data.headImgUrl : this.logo = res.data.data.logo
          // console.log(this.logo);
          // if(this.logo === '') {
          //   this.logo = logoUrl
          // }
          sessionStorage.setItem("user-login", JSON.stringify(res.data.data));
          // this.getLogo()
          if (nav) {
            if (this.user.userType == 1) {
              this.$router.push({ name: "userInfo" });
            }
          }
          window.location.reload();
        })
        .catch((err) => {
          this.$alert(err + "网络请求异常，请稍后再试！", "警告", {
            confirmButtonText: "确定",
            type: "error",
          });
        });
    },
    moveTab(index, e) {
      const width = e.target.offsetWidth;
      const indicator = document.querySelector(".indicator");
      indicator.style.transform = `translateX(${index * width}px)`;
      console.log(indicator.style.transform);
    },
    //点击位置导航进行跳转
    navPosition() {
      let that = this
      let content=that.searchValue.replace(/\s*/g,"")
      if(content == ''){
        that.$message.error('请输入搜索值！');
        return
      } 
      that.inputExpand = false
      that.$router.push({ name: "search", query: { content } }).then(
        clock =>{
          that.$router.go(0);
        }
      )
      // that.$router.go(0);
    },
    // 点击服务中心和供需对接二级菜单
    // 如果已经处于当前页，跳转到相应的模块
    navAndanchor(path, param) {
      if (this.$route.path === "/services/" && param === ".servicecenters") {
        window.scrollTo(0, 848);
      }
      if (this.$route.path === "/services/" && param === ".servicess") {
        window.scrollTo(0, 1910);
      }
      this.$router.push({
        name: path,
        params: {
          anchor: param,
        },
      });
    },
    // 埋点
    // getpvuv(){
    //   this.$ajaxPost(getPVUV,{
    //     ip: sessionStorage.getItem('ip'),
    //     directoryOne: "首页",
    //     directoryTwo: null,
    //     directoryThree: null,
    //     cookie: sessionStorage.getItem('random')
    //   })
    // }
  },
};
</script>

<style lang="less" scoped>
@media all and (min-width: 750px) {
  .mb-head {
    display: none;
  }
  .cover {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.2);
    z-index: 999;
  }
  .mark {
    position: fixed;
    z-index: 998;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background: black;
    opacity: 0.2;
  }
  .web-head {
    @keyframes slowDown {
      0% {
        transform: translateY(-100%);
      }
      100% {
        transform: translateY(0);
      }
    }
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    .search-box {
      width: 10rem;
      height: 3.75rem;
      overflow: hidden;
      position: absolute;
      border-radius: 0.06875rem;
      top: 0.55rem;
      left: 50%;
      z-index: 999;
      transform: translateX(-50%);
      box-shadow: 0 5px 5px rgba(0, 0, 0, 0.5);
      .search {
        width: 10rem;
        height: 3.75rem;
        background-color: #fff;
        .iconPosition {
          img {
            margin-top: 0.171875rem;
            width: 6rem;
          }
        }
        .searchWant {
          width: 6.52rem;
          height: 0.5rem;
          background-color: #ffffff;
          border-radius: 0.1rem;
          border: solid 0.02rem #4982dc;
          border-right: none;
          margin: 0.2rem auto;
          display: flex;
          justify-content: space-between;
          overflow: hidden;
          box-sizing: border-box;
          padding: 0;
          .searchValue {
            flex: 5;
            padding-left: 0.1rem;
            display: flex;
            align-items: center;
            i {
              font-size: 0.3rem;
              color: #5e86d8;
              margin-right: 0.1rem;
            }
            input {
              border: none;
              font-size: 0.25rem;
              outline: none;
              width: 5rem;
            }
          }
          .searchNow {
            flex: 1;
            border: none;
            font-size: 0.2rem;
            color: #fff;
            background-color: #4982dc;
            display: flex;
            align-items: center;
            justify-content: center;
            border: solid 0.04rem #4982dc;
            &:hover {
              cursor: pointer;
            }
          }
        }
        .everyone {
          width: 5.07rem;
          height: 0.59rem;
          margin: 0.5rem auto;
          p {
            margin-bottom: 0.257812rem;
            height: 0.19rem;
            font-size: 0.2rem;
            line-height: 0.48rem;
            color: #999999;
            display: flex;
            align-items: center;
            justify-content: center;
            span {
              display: inline-block;
              margin: 0 0.2rem;
              width: 0.3rem;
              height: 0.03rem;
              background-color: #999999;
              border-radius: 0.01rem;
            }
          }
          div {
            margin-top: 0.2rem;
            width: 5.07rem;
            font-size: 0.16rem;
            margin: auto;
            line-height: 0.34rem;
            letter-spacing: 0rem;
            color: #666666;
            display: flex;
            align-items: center;
            justify-content: center;
            span {
              display: inline-block;
              width: 0.02rem;
              height: 0.21rem;
              background-color: #4982dc;
              border-radius: 0.01rem;
              opacity: 0.4;
              margin: 0 0.3rem;
            }
          }
        }
      }
    }
    .head {
      width: 100%;
      height: 0.34375rem;
      line-height: 0.34375rem;
      background-color: #e7e7e7;
    }

    .login {
      height: 100%;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: @fontSize_14;
      color: white;
      > span {
        color: #4878b3;
        font-size: @fontSize_14;
      }
      .l-info {
        display: flex;
        align-items: center;
        &:hover {
          cursor: pointer;
        }
      }

      .l-search {
        padding: 0 0 0 0.128906rem;
        width: 0.739062rem;
        height: 0.223437rem;
        box-sizing: border-box;
        background-color: #ffffff;
        border-radius: 0.111719rem;
        display: flex;
        align-items: center;
        img {
          width: @fontSize_16;
          height: @fontSize_16;
        }
      }
      .serchInput {
        padding-left: 0.1rem;
        color: #aeaeae;
        box-sizing: border-box;
      }

      /deep/.el-dropdown {
        .el-icon-arrow-down {
          font-size: 0.154687rem;
        }
        .l-no2 {
          display: flex;
          align-items: center;
          margin-left: 0.2rem;
          i {
            color: #555;
            margin-left: 0.08rem;
            font-size: 0.131875rem;
          }
          span {
            cursor: pointer;
          }
          img {
            width: 0.22rem;
            height: 0.22rem;
            border-radius: 50%;
            margin-right: 0.1rem;
          }
          .username {
            font-size: 0.124687rem;
            color: #555;
          }
        }
      }

      .l-no {
        margin-left: 0.163281rem;
        span {
          color: #333;
          font-size: @fontSize_14;
          cursor: pointer;
        }

        & > span:nth-of-type(2){
          margin: 0 0.103125rem;
        }
        .spp{
          margin: 0 0.103125rem;
        }
        a{
          color: #111;
        }
      }
    }
    .contain {
      width: 100%;
      height: 1.289062rem;
      background: url("~@imgs/nav/head_bc.png") no-repeat center;
      background-size: 100% 100%;
      .type-page {
        height: 100%;
      }
      .logo {
        height: 100%;
        img {
          width: 3.482812rem;
        }
        .qr-code {
          display: flex;
          > div {
            display: flex;
            height: 100%;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            .pic {
              width: 0.6875rem;
              height: 0.6875rem;
              background: url("~@imgs/pages/home/erweimaa.jpg") no-repeat center;
              background-size: cover;
            }
            p {
              margin-top: 0.042969rem;
              color: #666;
              font-size: @fontSize_14;
            }
            &:last-child {
              margin-left: 0.515625rem;
              .pic {
                background-image: url("~@imgs/nav/commitment.png");
              }
            }
          }
        }
      }
    }
    .menus {
      width: 100%;
      height: 0.429687rem;
      background-color: @primary_color_1;
      .type-page {
        height: 100%;
      }
      .tabs {
        width: 100%;
        height: 100%;
        display: flex;
        .tab {
          flex: 1;
          position: relative;
          height: 100%;
          font-size: @fontSize_22;
          color: #fff;
          cursor: pointer;
          transition: all 0.5s;
          i {
            position: relative;
            z-index: 999;
            font-style: normal;
          }
          &::before {
            content: "";
            position: absolute;
            top: 50%;
            left: 50%;
            width: 0;
            height: 0;
            transition: all 0.5s;
            z-index: 1;
            border-top-left-radius: 0.27rem;
            border-bottom-left-radius: 0.27rem;
          }
          &::after {
            content: "";
            position: absolute;
            top: 50%;
            right: 50%;
            width: 0;
            height: 0;
            transition: all 0.5s;
            z-index: 1;
            border-top-right-radius: 0.27rem;
            border-bottom-right-radius: 0.27rem;
          }
          &:hover::before {
            top: 0;
            left: 0;
            width: 50%;
            height: 100%;
            background-color: #2e5e99;
            border-radius: 0;
          }
          &:hover::after {
            top: 0;
            right: 0;
            width: 50%;
            height: 100%;
            background-color: #2e5e99;
            border-radius: 0;
          }
        }

        .tab-active {
          width: 100%;
          height: 100%;
          background-color: #2e5e99;
        }
      }
    }
    .sub_menus {
      position: relative;
      display: flex;
      height: 0.464062rem;
      line-height: 0.464062rem;
      background-color: #f0f0f0;
      border-radius: 0 0 0.06875rem 0.06875rem;
      border: solid 1px #e8e8e8;
      border-top: none;
      a {
        flex: 1;
        color: #666;
        font-size: @fontSize_18;
        cursor: pointer;
        &:hover {
          color: @primary_color_1;
          border-bottom: 2px solid @primary_color_1;
        }
      }
      .indicator {
        color: @primary_color_1;
      }
    }
  }

  //弹出登录框
  .login1 {
    display: flex;
    position: fixed;
    font-size: 0.24rem;
    overflow: hidden;
    left: 50%;
    width: 550px;
    height: 583px;
    top: 50%;
    transform: translate(-50%, -50%);
    background-color: #fff;
    z-index: 1000;
    box-shadow: 0 0 0.1rem #86bbf8;
    border-radius: 0.085937rem;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    .toptitle {
      height: 0.8rem;
      width: 100%;
      background-color: #3a88f5;
      font-size: 0.24rem;
      line-height: 0.8rem;
      text-align: center;
      color: #fff;
      letter-spacing: 0.05rem;
      display: flex;
      justify-content: center;
      .sureType {
        background: #fff;
        color: #333;
      }
      p {
        margin: 0;
        width: 50%;
        &:nth-of-type(1) {
          border-right: 1px solid #6aa5f7;
        }
        &:hover {
          cursor: pointer;
        }
      }
    }
    .img {
      width: 3.09374rem;
      height: 3.09374rem;
      box-sizing: border-box;
      border-radius: 5px;
      img {
        border-radius: 5px;
        width: 100%;
        height: 100%;
        box-shadow: 0 0 0.1rem #86bbf8;
      }
    }
    .bottomNew {
      margin-bottom: 0.343749rem;
      width: 2.5rem;
      font-size: 0.18rem;
      height: 0.3rem;
      border-radius: 0.25rem;
      border: 0.01rem solid #6796e2;
      color: #6796e2;
      line-height: 0.3rem;
    }
    .userphone {
      font-size: 0.16rem;
      text-decoration: underline;
      color: #6796e2;
      &:hover {
        cursor: pointer;
      }
    }
  }
  .login2 {
    display: flex;
    position: fixed;
    font-size: 0.24rem;
    border-radius: 0.2rem;
    overflow: hidden;
    left: 50%;
    width: 550px;
    height: 583px;
    top: 50%;
    transform: translate(-50%, -50%);
    background-color: #fff;
    z-index: 1000;
    box-shadow: 0 0 0.1rem #86bbf8;
    border-radius: 0.085937rem;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    .userphone {
      display: block;
      margin-top: 0.2rem;
      font-size: 0.16rem;
      text-decoration: underline;
      color: #6796e2;
      &:hover {
        cursor: pointer;
      }
    }
    img {
      width: 1.10859rem;
      height: 0.472655rem;
      &:hover {
        cursor: pointer;
      }
    }
    .el-button {
      font-size: 0.2rem;
      width: 1rem;
      height: 0.4rem;
    }
    .toptitle {
      height: 0.8rem;
      width: 100%;
      background-color: #3a88f5;
      font-size: 0.22rem;
      line-height: 0.8rem;
      text-align: center;
      color: #fff;
      letter-spacing: 0.05rem;
      display: flex;
      align-items: center;
      justify-content: center;
      .sureType {
        background: #fff;
        color: #333;
      }
      p {
        margin: 0;
        width: 50%;
        &:nth-of-type(1) {
          border-right: 1px solid #6aa5f7;
        }
        &:hover {
          cursor: pointer;
        }
      }
    }
    .form-info {
      width: 4.5rem;
      margin: auto;
      /deep/.el-form {
        .el-form-item__label {
          height: 0.4rem;
        }
        .el-form-item {
          margin-bottom: 0.22rem;
        }
        .el-form-item__content {
          height: 0.4rem;
        }
        .el-form-item__label {
          font-size: 0.15rem;
        }
        .el-input__inner {
          float: left;
          width: 80%;
        }
        .el-form-item__error {
          font-size: 0.14rem;
        }
      }
    }
  }
  .operation {
    display: flex;
    justify-content: center;
    align-items: center;
    /deep/.el-button {
      border-radius: 0.1rem;
      margin: 0.2rem auto 0;
      height: 0.5rem;
      font-size: 0.2rem;
      width: 1.5rem !important;
      display: flex;
      align-items: center;
      justify-content: center;
      // margin-left: 0.2rem;
    }
  }

  .userupdata {
    padding-top: 0.2rem;
    width: 7rem !important;
    .line {
      height: 1px;
      width: 100%;
      background: #efefef;
      width: 5.5rem;
      margin: auto;
      margin: 0.6rem auto;
    }
    .chooseType {
      font-size: 0.2rem;
      margin-top: 0rem;
      display: flex;
      div {
        width: 50%;
        font-size: 0.18rem;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 0rem;
        color: #999999;
        padding: 0rem 0.5rem 0 0.8rem;
        text-align: left;
        .choosed {
          box-shadow: 0rem 0.03rem 0.15rem 0rem rgba(77, 150, 242, 0.35);
          color: #4982dc;
        }
        p {
          margin-bottom: 0.2rem;
          width: 2.21rem;
          height: 1.21rem;
          background-color: #ffffff;
          box-shadow: 0rem 0.03rem 0.15rem 0rem rgba(216, 216, 216, 0.35);
          border-radius: 0.1rem;
          margin: 0.2rem auto;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 0.2rem;
          font-weight: normal;
          font-stretch: normal;
          line-height: 0.48rem;
          letter-spacing: 0rem;
          color: #666666;
          &:hover {
            cursor: pointer;
          }
        }
      }
      /deep/.el-radio {
        .el-radio__inner {
          height: 0.14rem;
          width: 0.14rem;
          margin-left: 0.2rem;
        }
        .el-radio__label {
          font-size: 0.2rem;
        }
      }
    }
    .little-title {
      margin: 0.4rem 0;
    }
    width: 5.5rem;
    .form-info {
      /deep/.el-form .el-form-item {
        margin-bottom: 0.3rem;
        line-height: 0.2rem;
      }
    }
    .phoneNumber {
      display: flex;
      justify-content: space-between;
      padding-right: 0rem;
      align-items: center;
      .el-button {
        font-size: 0.16rem;
        width: 1.2rem;
        height: 0.4rem;
        border-radius: 0.05rem;
        margin: 0;
        margin-top: -0.02rem;
        margin-left: 0.2rem;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
    /deep/.el-steps {
      margin: 0.2rem auto;
      width: 6rem;
      .el-step__head {
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .el-step__icon {
        background: #c8c8c8;
        border: none;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 0.2rem;
        height: 0.33rem;
        width: 0.33rem;
      }
      .is-process {
        font-weight: normal;
      }
      .is-process {
        color: #c8c8c8;
      }
      .el-step__icon-inner {
        font-weight: normal;
      }
      .is-finish {
        .el-step__icon {
          background: #4386ee;
        }
      }
      .el-step__icon-inner {
        color: #fff;
      }
      .el-step__line {
        height: 0;
        border-bottom: 1px dashed #409eff;
        margin-top: 0.05rem;
      }
      .el-step__line-inner {
        display: none;
      }
      .el-step__title {
        font-size: 0.2rem;
      }
    }
    .el-button {
      font-size: 0.2rem;
      width: 3rem;
      margin: 0.4rem auto;
      border-radius: 0.05rem;
    }
  }
  .over {
    position: fixed;
    width: 100%;
    height: 100%;
    opacity: 0.7; //透明度为70%
    filter: alpha(opacity=70);
    top: 0;
    left: 0;
    z-index: 999;
    background-color: #111111;
  }
}
.el-dropdown-menu {
  padding: 0.085937rem 0;
  .el-dropdown-menu__item {
    padding: 0 0.085937rem;
    font-size: 0.1375rem !important;
    text-align: center;
    white-space: nowrap;
  }
}
@media screen and (max-width: 750px) {
  .web-head {
    display: none;
  }
  .smoke {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: #000;
    opacity: 0.3;
    z-index: 998;
  }
  .mb-head {
    // position: relative;
    // width: 100%;
    // height: 1rem;
    // background-image: linear-gradient(-90deg, #4d96f2 0%, #316fee 100%);
    // display: flex;
    // align-items: center;
    img {
      width: 4.48rem;
      height: 70%;
      margin: auto;
    }
    .nav {
      position: absolute;
      width: 0.42rem;
      height: 0.4rem;
      display: flex;
      left: 0.3rem;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .nav_menu {
      transition: 0.2s;
      position: absolute;
      top: 1.01rem;
      width: 3.9rem;
      height: 10.8rem;
      background-image: linear-gradient(-90deg, #4d96f2 0%, #316fee 100%);
      border-radius: 0rem 0.2rem 0.2rem 0.2rem;
      opacity: 0.95;
      transform: translateX(-100%);
      z-index: 999;
      ul {
        padding: 0;
        margin: 0;
        width: 3.93rem;
        list-style: none;
        li {
          width: 3.3rem;
          margin: auto;
          height: 0.88rem;
          font-family: SourceHanSansCN-Bold;
          font-size: 0.28rem;
          line-height: 0.9rem;
          letter-spacing: 0.011rem;
          color: #ffffff;
          text-align: center;
          border-bottom: 0.01rem solid #9bbff1;
        }
      }
    }
    .showNavMenu {
      transform: translateX(0);
      transition: 0.2s;
    }
    .nav_wx {
      margin-top: 0.45rem;
      img {
        width: 2.9rem;
        height: 2.9rem;
      }
      p {
        margin: 0;
        padding: 0;
        width: 100%;
        margin-top: -0.25rem;
        img {
          width: 0.32rem;
          height: 0.27rem;
          margin-right: 0.1rem;
        }
        font-size: 0.28rem;
        font-weight: normal;
        font-stretch: normal;
        line-height: 0.9rem;
        letter-spacing: 0.011rem;
        color: #ffffff;
      }
    }
  }
}



// 登录界面
.contart-main{
  .phoneimg{
    width: 80%;
    margin-top: 10px;
  }
  .wj{
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #999999;
  }
  /deep/.el-input--prefix .el-input__inner{
    border-radius: 10px;
  }
  /deep/.el-input__prefix{
    font-size: 18px;
  }
  border-radius: .12rem;
  position: absolute;
  z-index: 999;
  top: 50%;
  width: 6.84rem;
  background-color: white;
  .detele{
    position: absolute;
    top: -100px;
    right: -30px;
    cursor: pointer;
    img{
      width: 24px;
      height: 24px;
     
    }
  }
  .Change{
    position: absolute;
    right: 12px;
    display: flex;
     .into{
      height: 18px;
      font-size: .12rem;
      cursor: pointer;
    }
    .change{
      width: .3rem;
      height: .3rem;
      font-size: .14rem;
      cursor: pointer;
      img{
        width: .4rem;
        height: .4rem;
      }
    }
  }
  .contart{
  border-radius: .12rem;
  font-size: .24rem;
  width: 100%;
  height: 3.5rem;
  display: -webkit-box;
  hr{
    opacity: 0.5;
  }
  .left{
    border-radius: .12rem 0 0 0;
    width: 45%;
    padding: 6% 0 0 0;
    font-size: .29rem;
    background-color: #367ab7;
    .title{
      display: flex;
      justify-content: center;
      .title-zi{
        font-size: 22px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        line-height: 33px;
        color: #FFFFFF;
        opacity: 1;
      }
      .Sline{
        width: 36px;
        height: 0px;
        border: 1px solid #FFFFFF;
        background-color: #ffffff;
        margin: 0 10px;
        opacity: 0.3;
        margin-top: 16px;
      }
    }
    .img{
      display: flex;
      justify-content:center;
      width: 1.6rem;
      height: 1.6rem;
      margin: .2rem 0 0 0;
      border-radius: 8px;
      img{
        border-radius: 8px;
      }
    }
    .foot-sign{
      display: flex;
      flex-direction: column;
      align-self: center;
      font-size: 15px;
      // font-family: SourceHanSansCN-Regular;
      font-family: Source Han Sans CN;
      font-weight: 400;
      line-height: 27px;
      color: #9AB9D3;
      opacity: 1;
      p{
        margin: 0;
        &:nth-child(1){
          margin-top: 15px;
        }
      }
    }
  }
  .right{
    padding: 5% 2% 3% 0;
    width: 55%;
    display: flex;
    flex-direction: column;
    justify-content:center;
    .type,.type1{
      margin-top: .1rem;
      font-size: .22rem;
      display: flex;
      justify-content: space-between;
      margin: 0 10%;
      margin-bottom: .2rem;
      a{
        color: black;
      }
      p{
        font-size: .10rem;
        opacity: 0.5;
        margin: .1rem 0;
      }
      #Account,#Phone{
        font-family: Source Han Sans CN;
        width: 1.45rem;
        height: .39rem;
        font-size: .18rem;
        font-weight: 400;
        text-align: center;
        color: #333333;
        line-height: .39rem;
        border-radius: .99rem;
      }
      .active{
        font-weight: bold;
        color: #367AB7 !important;
        background-color: #F2F9FF ;
      }
      .active1{
        width: 110px;
        height: 33px;
        font-size: 22px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        line-height: 33px;
        color: #333333;
        opacity: 1;
        &::after{
          display: block;
          content:'';
          width: 110px;
          height: .02rem;
          background: rgba(211,226,239,0.3900);
        }
      }
    }
    .type1{
      display: block;
      text-align: start;
      width: 80%;
      margin: -0.3rem 10% .1rem 10%;
    }
    .type-main{
      .type-admin{
        .el-input{
          width: 80%;
          margin-bottom: 5%;
        }
        .verify{
          display: flex;
          width: 80%;
          margin: 0 10%;
          .el-button{
            width: 30%;
            height: .35rem;
            margin-left: .3rem;
          }
        }
      }
      .type-number{
        font-size: .16rem;
        .phone,.verify{
          display: flex;
          width: 80%;
          height: .3rem;
          margin: 0 10% 7% 10%;
        }
        .el-input{
          width: 100%;
        }
        .phone{
          .el-button{
            width: 35%;
            height: .35rem;
            margin-right: .2rem;
            cursor: default;
            &:hover{
              background-color: white;
              color: #606266;
            }
          }
        }
        .verify{
          .el-button{
            width: 35%;
            height: .35rem;
            margin-left: .2rem;
          }
          hr{
            margin: .04rem 0;
            height: 70%;
          }
        }
      }
      .el-button{
        width: 80%;
      }
      p{
        width: 80%;
        font-size: .12rem;
        display: flex;
        justify-content: space-between;
        margin: .1rem 10%;
      }
    }
    }
  .right-p{
    margin-top: .2rem;
  }  
  }
  .foot{
    border-radius: .12rem;
    font-size: .13rem;
    height: .4rem;
    line-height: .4rem;
    background-color: #F0F8FF;
    span{
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #999999;
    }
  }
}
.zhuce{
  .left{
    width: 100% !important;
    border-radius: .12rem !important;
  }
  .right{
    width: 0 !important;
    padding: 0 !important;
  }
}





// 搜索框过渡动画
.fade-enter-active,
.fade-leave-active {
  transition: all 0.7s;
}
.fade-enter,
.fade-leave-to {
  // opacity: 0;
  transform: translate(-50%, -150%) !important;
}
.fade-enter-to,
.fade-leave {
  transform: translate(-50%, 0) !important;
}
</style>
